module.exports = __webpack_public_path__ + "img/icon_trial_1.853c29af.png";